import i18n from "../i18n";

const CoachMonitoringSettings = (app) => {
  app.post(
    "/coach-monitoring-settings/save",
    async ({ api, assert, req, res, flash }) => {
      const { clientId, sendTimeOverride } = req.body;
      assert(
        clientId,
        400,
        i18n.t("coaching-portal:coachDailyMonitoringActions.workflowIdRequired")
      );

      try {
        await api(`coach-monitoring-settings/${clientId}`, {
          method: "PUT",
          body: { morningBrief: { sendTimeOverride } },
        });
        flash(
          "success",
          i18n.t(
            "coaching-portal:coachDailyMonitoringActions.successfullySaved"
          )
        );
        res.backDontScroll();
      } catch (e) {
        flash("error", e.message);
        res.backDontScroll();
      }
    }
  );
};

export default CoachMonitoringSettings;
